let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ekl6p")).then(() => parcelRequire('gTfIE'));